<cpb-list-renderer [key]="builderKey" [context]="context"></cpb-list-renderer>
